<template>
  <div>
    <popup name="asset-component-popup" height="auto" :scrollable="true">
      <server-error :error="error" />
      <AssetComponentCommandsModal
        v-if="assetComponent && !paymentParams"
        :assetComponent="assetComponent"
        :currencyCodes="currencyCodes"
        @closeModal="clearAssetComponentToEdit"/>
    </popup>
    <popup name="asset-popup" height="auto" :scrollable="true">
      <server-error :error="error" />
      <AssetCommandsModal
        v-if="assetParams"
        :asset="assetParams"
        @closeModal="clearAssetToEdit"
      />
    </popup>
    <popup name="payment-params-popup" height="auto" :scrollable="true">
      <server-error :error="error" />
      <PaymentParamsCommandsModal
        v-if="paymentParams && assetComponent"
        :paymentParams="paymentParams"
        :assetComponent="assetComponent"
        @closeModal="clearPaymentParamsToEdit"
      />
    </popup>
    <popup name="event-registry-popup" height="auto" :scrollable="true">
      <template v-if="showModalToformDirectoryEvent">
        <div data-cy="form-label" class="b-dialog__top-panel">
          <h2>{{$t('CONTENT.events.change_contract_condition')}}</h2>
          <button class="b-btn b-btn_border_none" @click.prevent="cancel">
            <dynamic-icon icon="close" />
          </button>
        </div>

        <div v-if="isShowWarning" class="b-notification b-notification__warning p-2">
          <div class="b-server-error__icon-wrap b-server-error__icon-wrap_type_duplicate p-2 mr-2">
            <dynamic-icon icon="warning" />
          </div>
          <div class="b-server-error__text">
            {{ warningMessage }}
          </div>
          <div class="b-form__container b-form__container_type_flex mt-3">
            <button class="b-btn b-btn_type_primary" @click.prevent="formEvent($event, false)">
              {{ $t('CONTENT.confirmSave') }}
            </button>
            <button
              class="b-btn b-btn_type_empty"
              @click.prevent="cancelWarning"
            >
              {{$t('CONTENT.cancel')}}
            </button>
          </div>
        </div>
        <server-error :error="error" />
        <form class="col-12 b-form b-dialog__form mt-4">
          <div class="row">
            <h2>{{assetComponent}}</h2>
          </div>
          <div class="row mb-5">
            <div class="col-8">
              <label>{{$t('CONTENT.events.commands')}}:</label>
              <ul v-if="commands.length > 0">
                <li
                  v-for="(command, index) in commands"
                  :key="index"
                >{{index + 1}} — {{$t("CONTENT.events." + command.commandName)}} ({{command.description}})</li>
              </ul>
              <div v-else>{{$t('CONTENT.events.chosen_commands')}}: 0</div>
            </div>
          </div>
          <div class="row mb-5">
            <div class="col-8">
              <label>{{$t('CONTENT.events.events_kind')}}:</label>
              <toggle-switch
                :items="availableEventsTypes"
                itemKey="key"
                itemName="name"
                v-bind:withHint=true
                @click="clickOnEventType"
              />
            </div>
          </div>
          <div class="row mb-5">
            <div class="col-4 b-form__container_min-width_200">
              <label>{{$t('CONTENT.events.event_date')}}:</label>
              <datepicker
                class="b-datepicker"
                v-model="selectedDateComp"
                :formatter="datepickerFormat"
                :disabled="isIntegrationEventDate || commands.find(command => command.commandName === 'AddLessor')||hasDeactivationEvent"/>
            </div>
            <div class="col-4 b-form__container_min-width_200">
              <label>{{$t('CONTENT.events.lat_event_date')}}:</label>
              <datepicker
                class="b-datepicker"
                v-model="selectedCreateEventDateComp"
                :formatter="datepickerFormat"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="b-form__container b-form__container_type_flex">
                <button
                  class="b-btn b-btn_type_primary"
                  type="submit"
                  @click="formEvent($event, true)"
                  :disabled="disabledSave"
                >{{$t('CONTENT.events.create_events_and_save')}}</button>
                <button
                  class="b-btn b-btn_type_empty"
                  @click.prevent="cancel">
                    {{$t('CONTENT.cancel')}}
                </button>
              </div>
            </div>
          </div>
        </form>
      </template>
    </popup>
  </div>
</template>

<script>
import dateConverter from '@/utils/converters/date.converter';
import datepickerFormat from '@/mixins/datepickerFormat.mixin';
import AssetComponentCommandsModal from '../modals/AssetComponentCommandsModal';
import PaymentParamsCommandsModal from '../modals/PaymentParamsCommandsModal';
import EventRegistryAPI from '../../api/EventRegistryAPI';
import TerminationOption from '../../../../components/registry/contracts/create/assets/TerminationOption';
import AssetCommandsModal from '../modals/AssetCommandsModal';
import {mapGetters} from "vuex";
import response from "vue2-datepicker";

export default {
  components: {
    TerminationOption,
    AssetComponentCommandsModal,
    PaymentParamsCommandsModal,
    AssetCommandsModal
  },
  props: {
    contractId: {
      required: true
    },
    currencyCodes: {
      required: true,
      type: Array
    }
  },
  mixins: [datepickerFormat],
  data() {
    return {
      error: null,
      showWidget: false,
      isShowWarning: false,
      warningMessage: null,
      selectedAssetComponentId: 1,
      selectedPaymentParamId: 1,
      selectedDate: null,
      selectedCreateEventDate: null,
      selectedEventType: null,
      eventIntegrationDate: null,
    };
  },
  computed: {
    ...mapGetters(['getContractSettings']),
    getDateAfterClosedPeriod() {
      const date = new Date(dateConverter.convertToDate(this.getContractSettings.lastClosePeriodDate));
      date.setDate(date.getDate() + 1);
      return date;
    },
    hasDeactivationEvent() {
      return this.commands.some(command => command.commandName === 'DeactivateEvent');
    },
    isIntegrationEventDate() {
      return this.$store.state.eventRegistryPlugin.integrationEventDate !== null;
    },
    availableEventsTypes() {
      if (this.hasDeactivationEvent) {
        return [
          {
            key: 'modification',
            name: `${this.$t('CONTENT.events.modification')}`,
            hint: `${this.$t('CONTENT.hints.modificationHint')}`,
          }];
      }
      return [
        {
          key: "modification",
          name: `${this.$t('CONTENT.events.modification')}`,
          hint: `${this.$t('CONTENT.hints.modificationHint')}`
        },
        {
          key: "revaluation",
          name: `${this.$t('CONTENT.events.revaluation')}`,
          hint: `${this.$t('CONTENT.hints.revaluationHint')}`
        }
      ];
    },
    assetComponent() {
      let assetComponent = this.$store.state.eventRegistryPlugin
        .selectedAssetComponent;
      if (assetComponent !== null) {
        this.$modal.show("asset-component-popup");
      }
      return assetComponent;
    },
    assetParams() {
      let asset = this.$store.state.eventRegistryPlugin
        .selectedAsset;
      if (asset !== null) {
        this.$modal.show("asset-popup");
      }
      return asset;
    },
    paymentParams() {
      let paymentParams = this.$store.state.eventRegistryPlugin
        .selectedPaymentParam;
      if (paymentParams !== null) {
        this.$modal.show("payment-params-popup");
      }
      return paymentParams;
    },
    showModalToformDirectoryEvent() {
      let eventRegistry = this.$store.state.eventRegistryPlugin
        .showModalToformDirectoryEvent;
      if (eventRegistry) {
        this.$modal.show("event-registry-popup");
      }
      return eventRegistry;
    },
    commands() {
      return this.$store.state.eventRegistryPlugin.commands;
    },
    selectedDateComp: {
      get() {
        const addLessorCommand = this.commands.find(command => command.commandName === 'AddLessor');
        if (this.hasDeactivationEvent) {
          const deactivation = this.commands.find(command => command.commandName === 'DeactivateEvent');
          const eventId = deactivation.eventIds[0];
          const currentEvent = this.$store.state.eventRegistryPlugin.directoryEvents.find(event => event.idInDB === eventId);
          this.selectedDate = currentEvent.eventDate;
          return dateConverter.convertToDate(currentEvent.eventDate);
        }
        if (this.selectedDate === null && addLessorCommand) {
          this.selectedDate = dateConverter.convertToString(addLessorCommand.eventDate);
          return dateConverter.convertToDate(this.selectedDate);
        } else
          if (this.selectedDate !== null) {
          const convertedStringDate = decodeURIComponent(this.selectedDate);
          return dateConverter.convertToDate(convertedStringDate);
        }
        return null;
      },
      set(newVal) {
        this.selectedDate = dateConverter.convertToString(newVal);
      },
    },
    selectedCreateEventDateComp: {
      get() {
        if (this.selectedCreateEventDate !== null) {
          const convertedStringDate = decodeURIComponent(this.selectedCreateEventDate);
          return dateConverter.convertToDate(convertedStringDate);
        }
        if (this.hasDeactivationEvent) {
          const dateAfterClosedPeriod = this.getDateAfterClosedPeriod;
          this.selectedCreateEventDate = dateConverter.convertToString(dateAfterClosedPeriod);
          return dateAfterClosedPeriod;
        }

        return null;
      },
      set(newVal) {
        const baseSelectedDate = dateConverter.convertToDate(this.selectedDate);

        if (newVal < baseSelectedDate) {
          this.selectedCreateEventDate = this.selectedDate;
        } else {
          this.selectedCreateEventDate = dateConverter.convertToString(newVal);
        }
      },
    },
    disabledSave() {
      return (
        this.$store.state.eventRegistryPlugin.commands.length == 0 ||
        this.selectedDate == null ||
        this.selectedCreateEventDate == null ||
        this.selectedEventType == null
      );
    }
  },
  watch: {
    eventIntegrationDate: {
      handler(date) {
        this.selectedDate = date;
      },
    },
    selectedDate: {
      immediate: true,
      handler(date, oldDate) {
        if (this.selectedCreateEventDate === null || this.selectedCreateEventDate === oldDate) this.selectedCreateEventDate = date
      },
    },
  },
  updated() {
    this.eventIntegrationDate = this.$store.state.eventRegistryPlugin.integrationEventDate;
  },
  methods: {
    async formEvent(e, useAdditionalValidation) {
      this.$fileLoadingManager.startLoading();
      e.preventDefault();
      try {
        this.error = null;
        this.isShowWarning = false;
        const convertedCommands = [];
        this.commands.forEach(command => {
          convertedCommands.push(command.serialize());
        });
        const event = {
          contractId: this.contractId,
          eventDate: this.selectedDate,
          createEventDate: this.selectedCreateEventDate,
          eventType: this.selectedEventType,
          commands: convertedCommands
        };
        const idInDb = this.$store.state.eventRegistryPlugin.integrationEventIdInDbList;
        const api = new EventRegistryAPI();

        const response = await api.applyCommands(event, idInDb, useAdditionalValidation);

        if(useAdditionalValidation) {
          let warning = null;

          if (response && response.warning) {
            warning = response.warning;
          }

          else if (response && response.data && response.data.warning) {
            warning = response.data.warning;
          }

          else if (response && response.headers && response.headers['x-warning']) {
            try {
              warning = JSON.parse(decodeURIComponent(response.headers['x-warning']));
            } catch {}
          }

          if (warning) {
            this.isShowWarning = true;
            this.warningMessage = warning.message;
            this.$fileLoadingManager.finishLoading();
            return;
          }
        }

        await this.$store.dispatch("getContractAggregateById", this.contractId);
        await this.$eventRegistryManager.loadContractVersions(this.contractId);
        await this.$eventRegistryManager.loadIntegrationEvents(this.contractId);
        this.$eventRegistryManager.toggleModalToFormDirectoryEvent(false);
        this.$eventRegistryManager.clearCommands();
        this.$store.commit("SET_CONTRACT_CHANGE_CONDITION_STATE", false);
        this.$modal.hide("event-registry-popup");
        this.$store.commit("eventRegistryPlugin/clearIndex");
        this.$store.commit("eventRegistryPlugin/clearIntegrationEventList");
        this.selectedDate = null;
        this.eventIntegrationDate = null;
        this.selectedEventType = null;
        this.$emit('updateCurrentContract')
        this.$toast.success(this.$t('NOTIFY.event_applied'));
      } catch (e) {
        this.onException(e)
      }
      this.$fileLoadingManager.finishLoading();
    },

    cancelWarning() {
      this.isShowWarning = false;
      this.warningMessage = null;
      this.$eventRegistryManager.toggleModalToFormDirectoryEvent(false);
      this.$eventRegistryManager.clearCommands();
      this.$store.commit("SET_CONTRACT_CHANGE_CONDITION_STATE", false);
      this.$modal.hide("event-registry-popup");
      this.$store.commit("eventRegistryPlugin/clearIndex");
      this.$store.commit("eventRegistryPlugin/clearIntegrationEventList");
      this.selectedDate = null;
      this.eventIntegrationDate = null;
      this.selectedEventType = null;
      this.$emit('updateCurrentContract');
    },

    onException(e) {
      this.error = e
      let message = this.$t('ERRORS.UnknownError')

      if(e.response === undefined) {
        message = this.$t('ERRORS.NetworkError')
      } else {
        const status = e.response.status
        if(status === 400) message = e.response.data.exceptions[0].message
        if(status === 500) message = this.$t('ERRORS.SystemError')
      }

      this.$toast.error(message);
    },
    clickOnEventType(e) {
      this.selectedEventType = e;
    },
    clearPaymentParamsToEdit() {
      this.$eventRegistryManager.editPaymentParamsCommands(null);
      this.$eventRegistryManager.editAssetCommands(null);
      this.$modal.hide('payment-params-popup');
      this.clearAssetComponentToEdit();
    },
    clearAssetComponentToEdit() {
      this.$eventRegistryManager.editAssetComponentCommands(null);
      this.$modal.hide("asset-component-popup");
    },
    clearAssetToEdit() {
      this.$eventRegistryManager.editAssetCommands(null);
      this.$modal.hide("asset-popup");
    },
    cancel() {
      if (this.hasDeactivationEvent) {
        this.$store.commit('eventRegistryPlugin/deleteAllCommands');
      }
      this.error = null;
      this.selectedEventType = null;
      this.$modal.hide("event-registry-popup");
      this.$eventRegistryManager.toggleModalToFormDirectoryEvent(false);

    }
  }
};
</script>

